import { BASE_URL, NAME_KEY, USERID_KEY, USER_TYPE_FORM, TOKEN_KEY, USER_TYPE_ID, USER_TYPE_NAME, USER_EMAIL } from 'constant'
import {
  AUTH_LOGIN_URL,

  AUTH_LOGIN_ERROR,
  AUTH_LOGIN_LOADING,
  AUTH_LOGIN_SUCCESS,

  AUTH_LOGOUT_LOADING,
  AUTH_LOGOUT_SUCCESS
} from './constant'

const authLoginError = (bool) => {
  return {
    type: AUTH_LOGIN_ERROR,
    authLoginError: bool
  }
}

const authLoginLoading = (bool) => {
  return {
    type: AUTH_LOGIN_LOADING,
    authLoginLoading: bool
  }
}

const authLoginSuccess = (bool, account) => {
  return {
    type: AUTH_LOGIN_SUCCESS,
    authLoginSuccess: bool,
    isAuthenticated: bool,
    account
  }
}

export function doLogin(cred) {
  return (dispatch) => {
    dispatch(authLoginSuccess(false, null))
    dispatch(authLoginError(false))
    dispatch(authLoginLoading(true))

    let config = {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json'
      },
      body: JSON.stringify(cred)
    }
    fetch(BASE_URL + AUTH_LOGIN_URL, config)
      .then((response) => {
        if (!response.ok) {
          throw Error(response.statusText)
        }
        dispatch(authLoginLoading(false))
        return response
      })
      .then((response) => response.json())
      .then((account) => {
        localStorage.removeItem(NAME_KEY)
        localStorage.removeItem(USERID_KEY)
        localStorage.removeItem(TOKEN_KEY)
        localStorage.removeItem(USER_TYPE_ID)
        localStorage.removeItem(USER_TYPE_FORM)
        account.data.actions.map((val, idx) => {
          return localStorage.removeItem(`${val.action_key}@tol-laut-ternak`)
        })

        if (account.success) {
          localStorage.setItem(NAME_KEY, account.data.user.user_profile.user_profile_name)
          localStorage.setItem(USERID_KEY, account.data.user.id)
          localStorage.setItem(TOKEN_KEY, account.data.token)
          localStorage.setItem(USER_TYPE_ID, account.data.user.user_type_user_type_id)
          localStorage.setItem(USER_TYPE_FORM, account.data.user.user_type.user_type_form)
          localStorage.setItem(USER_TYPE_NAME, account.data.user.user_type.user_type_name)
          localStorage.setItem(USER_EMAIL, account.data.user.user_email)

          account.data.user.user_type.acls.map((val, idx) => {
            return localStorage.setItem(`${val.action.action_key}@tol-laut-ternak`, val.acl_allowed)
          })
          dispatch(authLoginSuccess(true, account))
        } else {
          dispatch(authLoginLoading(false))
          dispatch(authLoginError(true))
        }
      })
      .catch((err) => {
        dispatch(authLoginLoading(false))
        dispatch(authLoginError(true))
      })
  }
}

const authLogoutLoading = (bool) => {
  return {
    type: AUTH_LOGOUT_LOADING,
    authLogoutLoading: bool
  }
}

const authLogoutSuccess = (bool) => {
  return {
    type: AUTH_LOGOUT_SUCCESS,
    authLogoutSuccess: bool,
    isAuthenticated: !bool
  }
}

export function doLogout() {
  return dispatch => {
    dispatch(authLogoutLoading(true))
    localStorage.removeItem(NAME_KEY)
    localStorage.removeItem(USERID_KEY)
    localStorage.removeItem(TOKEN_KEY)
    localStorage.removeItem(USER_TYPE_ID)
    localStorage.removeItem(USER_TYPE_FORM)
    dispatch(authLogoutLoading(false))
    dispatch(authLogoutSuccess(true))
  }
}
